var map = {
	"./Birmingham.svg": 6535,
	"./Liverpool.svg": 8753,
	"./Pokeball.svg": 9110,
	"./Sheffield.svg": 8445,
	"./badge.png": 5130,
	"./circle-info-solid.svg": 1682,
	"./circle-solid.svg": 1844,
	"./crown1.png": 2443,
	"./door.svg": 2955,
	"./karl.jpg": 369,
	"./paula.png": 2527,
	"./pd-logo.png": 701,
	"./phil.jpg": 2967,
	"./pin.svg": 8725,
	"./pokemonDetective.jpg": 6926,
	"./rectangle-xmark-solid.svg": 9566,
	"./serena.webp": 9334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;